import React, { Component } from 'react';
import ReactStars from 'react-stars';
import { Tooltip } from 'reactstrap';

class InfoBlockSmall extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tooltipOpen: false
    };
    this.toggle = this.toggle.bind(this);

  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  render() {
    return (
      <div className="info-block-small" id={this.props.tooltipId}>
        <p className="title font-size-tiny mb-1 label-light ls-1 font-lg-8-12">
          {this.props.title}
          {
            this.props.tooltipText ? (<i className="mdi mdi-information-outline tooltip-indicator" />) : ''
          }
        </p>
        { this.props.descriptionType === 'rating' ? (
          <ReactStars
            count={5}
            size={16}
            half={true}
            edit={false}
            value={parseInt(this.props.description)}
            color2={'#ffd700'} 
            className="star-rating"
            />
          ) : (
            <p className={"amount font-size-small mb-0 font-weight-medium font-lg-12-20 ls-1 text-" + this.props.color}>
              {this.props.description}
            </p>
          )
        }

        {
          this.props.tooltipText ? (
            <Tooltip placement="right" isOpen={this.state.tooltipOpen} target={this.props.tooltipId} toggle={this.toggle}>
              {this.props.tooltipText}
            </Tooltip>
          ) : ''
        }
      </div>
    );
  }
}

export default InfoBlockSmall;
